import { merge } from '../../helper';

import exExternal from '../../external';
import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        bootstrap: {
            enabled: true,
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    const elements: Record<string, any> = {};

    // Create element (popovers)
    const elPopovers = exElement.create({
        merge: defConfig,
    });
    elements.element = elPopovers;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // If using bootstrap
    if (defConfig.bootstrap?.enabled === true) {
        // Bootstrap (popovers)
        const bsPopovers = new exExternal.bootstrap.Popover(elements.element, defConfig.bootstrap);
        elements.bs = bsPopovers;
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    //
}

// ----------------------------------------------------------------------------

export { create };
